import { render, staticRenderFns } from "./QuizNightConfigurationOverview.vue?vue&type=template&id=d46b0d22&scoped=true"
import script from "./QuizNightConfigurationOverview.vue?vue&type=script&lang=js"
export * from "./QuizNightConfigurationOverview.vue?vue&type=script&lang=js"
import style0 from "./QuizNightConfigurationOverview.vue?vue&type=style&index=0&id=d46b0d22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46b0d22",
  null
  
)

export default component.exports